import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ApplicationScenario } from '../../../../api/types';

const useScenarioOptions = () => {
    const { t } = useTranslation(['moduleDetails']);

    return useMemo(
        () => [
            {
                value: ApplicationScenario.Financing,
                label: t('moduleDetails:explanations.scenarios.Financing.label'),
            },
            {
                value: ApplicationScenario.Insurance,
                label: t('moduleDetails:explanations.scenarios.Insurance.label'),
            },
            {
                value: ApplicationScenario.Payment,
                label: t('moduleDetails:explanations.scenarios.Payment.label'),
            },
            {
                value: ApplicationScenario.Appointment,
                label: t('moduleDetails:explanations.scenarios.Appointment.label'),
            },
            {
                value: ApplicationScenario.LeadCapture,
                label: t('moduleDetails:explanations.scenarios.LeadCapture.label'),
            },
        ],
        [t]
    );
};

export default useScenarioOptions;
